/**
 * Tên tiếng Hoa của giá trị trong danh mục Cài đặt (Roary 09/10/2026: loại sản phẩm hiện tiếng Anh trên, tiếng Hoa dưới).
 *
 * Giá trị lưu trên sản phẩm VẪN là chữ tiếng Anh như cũ (`products.type`), tên tiếng Hoa chỉ là nhãn hiển thị đặt trong
 * `businessOperations.optionLabelsZh[<danh mục>][<giá trị>]` — đổi tên tiếng Hoa không phải sửa 1.531 sản phẩm. Để riêng,
 * không nhét vào `optionLists`: phần đọc danh mục bỏ mọi danh sách không phải mảng chữ.
 */
export const ZH_LABEL_LISTS = ["productTypes"] as const;
export type ZhLabelList = (typeof ZH_LABEL_LISTS)[number];

export type OptionLabelsZh = Partial<Record<string, Record<string, string>>>;

/** Tên tiếng Hoa của một giá trị, `null` khi admin chưa nhập. */
export function optionLabelZh(labels: OptionLabelsZh | null | undefined, list: string, value: string | null | undefined): string | null {
  if (!value) return null;
  const label = labels?.[list]?.[value]?.trim();
  return label ? label : null;
}

/**
 * Chuẩn hoá bản lưu: chỉ giữ giá trị còn trong danh mục, bỏ ô trống. Xoá một loại khỏi danh mục thì tên tiếng Hoa của nó
 * đi theo, không đọng lại trong cài đặt.
 */
export function normalizeOptionLabels(labels: Record<string, string> | null | undefined, values: readonly string[]): Record<string, string> {
  const out: Record<string, string> = {};
  for (const value of values) {
    const label = labels?.[value]?.trim();
    if (label) out[value] = label;
  }
  return out;
}
